class DeployerElement extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.setupVariables();
    this.setupEvents();
    this.registerDeployerElement();
  }
  
  setupVariables() {
    throw new Error("setupVariables is not implemented");
  }
  
  setupEvents() {
    throw new Error("setupEvents is not implemented");
  }

  registerDeployerElement() {
    throw new Error("Deployer Element not registered");
  }
}

if (!window.customElements.get("deployer-element")) {
  window.customElements.define("deployer-element", DeployerElement);
}

export {
  DeployerElement
}